import { assertEvent } from 'xstate';
import { ActionEventParams } from '../../../../lib/types';
import { EstimatedSpendContext } from './estimatedSpendMachine';
import { SendUpdateEstimatedSpend } from './types/events';

/**
 * Gets estimated spend params from event
 * @param ActionEventParams<EstimatedSpendContext, SendUpdateEstimatedSpend>
 * @returns EstimatedSpendContext
 */
export const getAssignEstimatedSpendParams = ({
  event,
}: ActionEventParams<
  EstimatedSpendContext,
  SendUpdateEstimatedSpend
>): EstimatedSpendContext => {
  assertEvent(event, 'SEND_UPDATE_ESTIMATED_SPEND');

  return event.params;
};
